import { createAction, props } from '@ngrx/store'
import { User } from '../auth/auth.state'

// Load all users
export const loadUsers = createAction('[User] Load Users')

export const loadUsersSuccess = createAction(
  '[User] Load Users Success',
  props<{ users: User[] }>()
)

export const loadUserFailure = createAction('[User] Load User Failure', props<{ error: string }>())

// Load a single user
export const loadUserById = createAction('[User] Load User By Id', props<{ id: string }>())

export const loadUserByIdSuccess = createAction(
  '[User] Load User By Id Success',
  props<{ user: User }>()
)

// Load Employees
export const loadEmployees = createAction(
  '[User] Load Employees',
  props<{ params?: string | null; page?: number; limit?: number }>()
)

export const loadEmployeesSuccess = createAction(
  '[User] Load Employees Success',
  props<{
    totalCount: number
    activeCount: number
    inactiveCount: number
    newJoineeCount: number

    employees: User[]
  }>()
)

export const loadEmployeesFailure = createAction(
  '[User] Load Employees Failure',
  props<{ error: string }>()
)

//Block Employee
export const blockEmployee = createAction(
  '[User] Block Employee',
  props<{ id: string; disabled: boolean }>()
)

export const blockEmployeeSuccess = createAction(
  '[User] Block Employee Success',
  props<{ user: User }>()
)

export const blockEmployeeFailure = createAction(
  '[User] Block Employee Failure',
  props<{ error: string }>()
)

//Delete Employee
export const deleteEmployee = createAction('[User] Delete Employee', props<{ id: string }>())

export const deleteEmployeeSuccess = createAction(
  '[User] Delete Employee Success',
  props<{ id: string }>()
)

export const deleteEmployeeFailure = createAction(
  '[User] Delete Employee Failure',
  props<{ error: any }>()
)

//Create Employee
export const createEmployee = createAction(
  '[User] Create Employee',
  props<{ payload: any }>() // or specify each field
)

export const createEmployeeSuccess = createAction(
  '[User] Create Business Success',
  props<{ user: User }>()
)

export const createEmployeeFailure = createAction(
  '[User] Create Employee Failure',
  props<{ error: any }>()
)

// Load Employee by ID
export const loadEmployeeById = createAction('[User] Load Employee By ID', props<{ id: string }>())

export const loadEmployeeByIdSuccess = createAction(
  '[User] Load Business By ID Success',
  props<{ user: User }>()
)

export const loadEmployeeByIdFailure = createAction(
  '[User] Load Employee By ID Failure',
  props<{ error: string }>()
)

//Update Employee
export const updateEmployee = createAction(
  '[Employee] Update Employee',
  props<{ id: string; data: FormData }>()
)

export const updateEmployeeSuccess = createAction(
  '[Employee] Update Employee Success',
  props<{ user: User }>()
)

export const updateEmployeeFailure = createAction(
  '[Employee] Update Employee Failure',
  props<{ error: any }>()
)

export const resetEmployeeState = createAction('[User] Reset State')

//portal access Employee
export const portalAccessEmployee = createAction(
  '[User] Portal Access Employee',
  props<{ id: string; portalAccess: boolean }>()
)

export const portalAccessEmployeeSuccess = createAction(
  '[User] Portal Access Employee Success',
  props<{ user: User }>()
)

export const portalAccessEmployeeFailure = createAction(
  '[User] Portal Access Employee Failure',
  props<{ error: string }>()
)
export const resetUserState = createAction('[User] Reset State')
